<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import LazyContent from '../UI/Loading/LazyContent.vue'
import Loader from '../UI/Loading/Loader.vue'
import InvoiceDetailModal from '../Invoice/InvoiceDetailModal.vue'

export default {
  components: { InvoiceDetailModal, Loader, LazyContent },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    contractId: { type: [String, Number], required: true },
    supplierInvoices: { type: Boolean, default: false },
  },

  data() {
    return {
      invoices: [],
      loading: false,
      selectedInvoice: null,
      openingInvoiceId: null,
    }
  },

  methods: {
    async fetchInvoices() {
      this.loading = true
      try {
        const endpoint = this.supplierInvoices ? 'supplier-invoices' : 'invoices'
        this.invoices = await this.getJSON('contracts/' + this.contractId + '/' + endpoint)
      } catch (error) {
        this.toast(error)
      } finally {
        this.loading = false
      }
    },
    async download(id, downloadName) {
      await this.downloadFile(
        `contracts/${this.contractId}/invoices/${id}/download`,
        downloadName ?? `Facture-${id}.pdf`,
      )
    },
    async openInvoiceModal(invoice) {
      this.openingInvoiceId = invoice.id
      try {
        this.selectedInvoice = invoice
        await this.$refs['invoice-detail-modal'].openModal(invoice.id)
      } finally {
        this.openingInvoiceId = null
      }
    },
    closeInvoiceModal() {
      this.$refs['invoice-detail-modal'].close(false)
      this.selectedInvoice = null
    },
  },
  async beforeMount() {
    await this.fetchInvoices()
  },
}
</script>
<template>
  <div class="document-list">
    <LazyContent :loading="loading">
      <div class="table-responsive-sm" style="overflow-x: auto">
        <table class="table table-striped table-hover fs-16">
          <thead>
            <tr>
              <th>{{ $t('document.table.labelDocument') }}</th>
              <th>{{ $t('invoice.list.name') }}</th>
              <th>{{ $t('invoice.list.emission') }}</th>
              <th>{{ $t('invoice.list.dueAt') }}</th>
              <th>{{ $t('invoice.list.type') }}</th>
              <th>{{ $t('invoice.list.amount') }}</th>
              <th>{{ $t('invoice.list.status') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="invoice in invoices" :key="invoice.id">
              <td>
                {{ invoice.number ? invoice.number : $t('invoice.list.draft') }}
              </td>
              <td>
                <button
                  v-if="invoice.type === 'SUPPLIER'"
                  type="button"
                  class="btn btn-link d-flex align-items-center gap-2"
                  :disabled="openingInvoiceId === invoice.id"
                  @click="openInvoiceModal(invoice)"
                >
                  <Loader v-if="openingInvoiceId === invoice.id" />
                  <span>{{ invoice.name }}</span>
                </button>
                <span v-else>{{ invoice.name }}</span>
              </td>
              <td>
                {{ $d(new Date(invoice.createdAt), 'date') }}
              </td>
              <td>
                {{ $d(new Date(invoice.dueAt), 'date') }}
              </td>
              <td>
                {{ $t('invoice.type.' + invoice.invoiceType) }}
              </td>
              <td>
                {{ $n(Number(invoice.amount), 'currency') }}
              </td>
              <td>
                {{ $t('invoice.status.' + invoice.status + '.label') }}
              </td>
              <td>
                <i class="fas fa-download" style="cursor: pointer" @click="download(invoice.id, invoice.name)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <InvoiceDetailModal id="invoice-detail-modal" ref="invoice-detail-modal" @icon-close="closeInvoiceModal" />
    </LazyContent>
  </div>
</template>
